import dayjs from "dayjs";
import { useEffect, useState } from "react";
import moment from "moment";
export function getMonth(date = dayjs()) {
  const currDate = dayjs(date);
  const month = Math.floor(currDate.month());
  const year = currDate.year();
  const firstDayOfTheMonth = dayjs(new Date(year, month, 1)).day();
  let currentMonthCount = 0 - firstDayOfTheMonth;
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let counter = 0;

  const daysMatrix = new Array(6).fill([]).map((row, rowIndex) => {
    return new Array(7).fill(null).map(() => {
      if (rowIndex === 0) {
        return daysOfWeek[counter++];
      } else {
        currentMonthCount++;
        return dayjs(new Date(year, month, currentMonthCount));
      }
    });
  });
  return daysMatrix;
}

export function getWeek(date = dayjs()) {
  let startOfWeek = date.startOf("week");
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let counter = 0;

  const daysMatrix = new Array(1).fill([]).map(() => {
    return new Array(7).fill(null).map(() => {
      return startOfWeek.add(counter++, "day");
    });
  });
  daysMatrix.unshift(daysOfWeek);
  return daysMatrix;
}

export function getYearMonths(date = dayjs()) {
  let year = dayjs(date).year();
  const months = [];
  for (let month = 0; month < 12; month++) {
    months.push(dayjs(new Date(year, month, 1)));
  }
  return months;
}

export function getTodayTime(date = dayjs()) {
  const today = dayjs(date).startOf("day");
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    times.push(today.add(hour, "hour"));
  }
  return times;
}

export function getUpcomingEvents(eventList) {
  // Get the current date and time
  const currentDate = new Date();

  // Filter the eventList to keep only upcoming events
  const upcomingEvents = eventList.filter((event) => {
    // Get the start date and time of the event
    const eventStartDate = new Date(event.start.dateTime);

    // Compare the start date and time of the event with the current date and time
    return eventStartDate > currentDate;
  });

  // Sort the upcomingEvents array in ascending order based on the start date and time
  upcomingEvents.sort((a, b) => {
    const dateTimeA = new Date(a.start.dateTime).getTime();
    const dateTimeB = new Date(b.start.dateTime).getTime();
    return dateTimeA - dateTimeB;
  });

  // return the upcomingEvents array
  return upcomingEvents;
}

export function getTodayUpcomingEvents(eventList) {
  // Get the current date
  const currentDate = new Date();

  // Get the start and end of the current day
  const startOfDay = new Date(currentDate);
  startOfDay.setHours(0, 0, 0, 0);

  const endOfDay = new Date(currentDate);
  endOfDay.setHours(23, 59, 59, 999);

  // Filter the eventList to keep only events happening today
  const todaysEvents = eventList.filter((event) => {
    // Get the start date and time of the event
    const eventStartDate = new Date(event.start.dateTime);

    // Check if the event is today
    return eventStartDate >= startOfDay && eventStartDate <= endOfDay;
  });

  // Sort the todaysEvents array in ascending order based on the start date and time
  todaysEvents.sort((a, b) => {
    const dateTimeA = new Date(a.start.dateTime).getTime();
    const dateTimeB = new Date(b.start.dateTime).getTime();
    return dateTimeA - dateTimeB;
  });

  // return the todaysEvents array (it will be empty if there are no events today)
  return todaysEvents;
}

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string?.charAt(0).toUpperCase() + string.slice(1);
};

export const permissionDeniedMessage = "You do not have permission to view this page. Please contact the administrator for more information";

// Detects HTML tags or entities in a string value to block markup injection in inputs.
export const containsHtml = (value) => {
  if (typeof value !== "string") return false;
  // [^>]* (negated class) is mutually exclusive with the trailing ">",
  // so the match is linear-time and avoids catastrophic backtracking.
  const htmlTagPattern = /<\/?[a-z][^>]*>/i;
  const htmlEntityPattern = /&(?:#\d+|#x[0-9a-f]+|[a-z]+);/i;
  return htmlTagPattern.test(value) || htmlEntityPattern.test(value);
};

export {
  enableAngleBracketInputFilter,
  isTextEntryElement,
  stripAngleBrackets,
} from "./angleBracketInputFilter";


export function NotificationImg(data) {
  const listimage = data
  console.log(listimage, data)
  return (
    <img
      src={listimage}
      alt="MaleIcon"
    />
  )
}
export const buttonStyle = {
  background: "rgb(29, 91, 191)",
  color: "rgb(255, 255, 255)",
  padding: "2px 20px",
  height: "32px",
  margin: "9px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "3px",
};


export const formatTime = (timeString) => {
  const [hours, minutes, seconds] = timeString?.split(':')?.map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(seconds);

  let formattedHours = date.getHours();
  const ampm = formattedHours >= 12 ? 'PM' : 'AM';
  formattedHours = formattedHours % 12;
  formattedHours = formattedHours ? formattedHours : 12;

  const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}



export const dateFormat = (data, type) => {
  if (data && data !== '') {
    // Default format
    let format = 'MM/DD/YYYY';

    // Apply different formats based on type parameter
    switch (type) {
      case 'short':
        format = 'MM/DD/YY';
        break;
      case 'withTime':
        format = 'MM/DD/YYYY | HH:mm';
        break;
      case 'fullTime':
        format = 'HH:mm:ss';
        break;
      case 'withTimeAMPM':
        format = 'MM/DD/YYYY | HH:mm A';
        break;
      case 'fullMonthMeeting':
        format = 'MMMM DD, YYYY';
        break;
      case "timeAMPM":
        format = "hh:mm A";
        break;
      // Add more "
      // custom formats as needed
      default:
        // Use default format 'MM/DD/YYYY'
        format = 'MM/DD/YYYY'
        break;
    }

    return `${moment(data).format(format)}`;
  }
  return '';
}
export const dateFormatRever = data => {

  if (data && data !== '') {
    const timestamp = moment(data).utc().format();
    console.log('dataFormatRever', timestamp, data)
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${month}-${day}-${year}`;
    return formattedDate
  }
  return ''
}

export const dateUtcRever = (data) => {
  if (data && data !== '') {
    const timestamp = moment(data).utc().format();
    console.log('dataFormatRever', timestamp, data);
    const date = moment.utc(timestamp);
    const formattedDate = date.format("MM-DD-YYYY");
    return formattedDate

  }
  return ''
}
export const formatDateFunToAll = dateFormat;
export const dateTimeFormat = data => {
  if (data && data !== '') {
    const originalDateString = data;
    const date = new Date(originalDateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');
    const formattedDate = `${month}-${day}-${year} | ${hours}:${minutes}`;
    return formattedDate
  }
  return ''
}

export const formatDateTimeISO = (isoString) => {
  const date = new Date(isoString);
  const options = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  const [monthDay, time] = date?.toLocaleString('en-US', options)?.split(', ');

  // const suffixes = ['th', 'st', 'nd', 'rd'];
  const day = date.getDate();
  let suffix = 'th';

  if (day % 10 === 1 && day !== 11) {
    suffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
    suffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
    // eslint-disable-next-line no-unused-vars
    suffix = 'rd';
  }
  // const suffix = suffixes[(day % 10)] || 'th';

  return `Begins ${monthDay} at ${time}`;
};
export const getStartAndEndDates = (value) => {
  const currentDate = new Date();

  const formatDate = (date) => {
    const year = date.getFullYear();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is zero-based, so we add 1
    return `${year}-${day}-${month}`;
  };

  if (value === 'month') {
    // Get the start and end of the current month
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  }

  if (value === 'year') {
    // Get the start and end of the current year
    const startDate = new Date(currentDate.getFullYear(), 0, 1);
    const endDate = new Date(currentDate.getFullYear(), 11, 31);
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  }

  return null;
};

export const getTimeFromDate = data => {
  if (data && data !== '') {
    const date = new Date(data);
    date.setHours(3);
    date.setMinutes(20);
    date.setSeconds(0);
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    return formattedTime
  }
  return ''
}

export const todatDateInfo = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const date = today.getDate();

  return {
    year: year,
    month: month,
    date: date
  }
}


export const convertDateFormat = (dateStr) => {
  let date = new Date(dateStr)
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  let day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}


export const getFiles = (files) => {
  const allFiles = {
    image: [],
    doc: [],
    video: [],
    files: false
  };

  const imageExtension = ["jpg", "jpeg", "png", "gif", "tiff", "tif", "bmp", "svg", "webp"];
  const documentExtension = ["pdf", "doc", "docx", "txt"];
  const videoExtension = ["mp4", "mov", "avi"];

  files?.forEach((fileObj) => {
    const file = fileObj["0"] ? fileObj["0"] : fileObj;
    if (!file) return;
    let url = file?.id ? file?.files : URL.createObjectURL(file);
    let fileName = file.file_name || file?.name?.split(".")[0] || "";
    let extension = "";
    if (file?.files && typeof file?.files === 'string') {
      const urlParts = file.files.split('.');
      if (urlParts?.length > 1) {
        extension = urlParts[urlParts?.length - 1].toLowerCase();
      }
    } else if (file?.name) {
      // Fallback to the name property if available
      extension = file.name.split(".").pop() || "";
    }
    let rowId = fileObj?.row_id ? fileObj?.row_id : undefined

    if (imageExtension.includes(extension.toLowerCase())) {
      allFiles.image.push({
        ...file,
        name: fileName,
        fileurl: url,
        row_id: rowId
      });
      allFiles.files = true;
    } else if (documentExtension.includes(extension.toLowerCase())) {
      allFiles.doc.push({
        ...file,
        name: fileName,
        fileurl: url,
        row_id: rowId
      });
      allFiles.files = true;
    } else if (videoExtension.includes(extension.toLowerCase())) {
      allFiles.video.push({
        ...file,
        name: fileName,
        fileurl: url,
        row_id: rowId
      });
      allFiles.files = true;
    }
  });
  return allFiles;
}

export const fileNameFromUrl = (file) => {
  let filename = ''
  if (file !== '') {
    filename = file?.split('/').pop();
  }
  return filename
}

export const fileNameString = (data) => {

  const fileNames = data?.map(item => item?.files?.split('/')?.pop());
  const firstImageName = fileNames[0].slice(0, 6);
  const remainingImagesCount = fileNames?.length - 1;
  return {
    filename: firstImageName,
    fullName: fileNames[0],
    remainingCount: remainingImagesCount
  };
}
export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const FormLabelRequired = ({ required, children, className = "" }) => (
  <label className={`block text-sm font-bold text-gray-700 ${className}`}>
    {children}
    {required && children && <span className="text-red-wcag ml-1">*</span>}
  </label>
)

export function formatRenderCellDateValues(value) {
  if (value !== "" && value !== null && value !== undefined && value !== ". . .") {
    return dateFormat(value)
  }
  return ". . ."
}
export function formatRenderCellTimeValues(value) {
  if (value !== "" && value !== null && value !== undefined && value !== ". . .") {
    return dateFormat(value, "fullTime")
  }
  return ". . ."
}

export function formatTableNullValues(rowData) {
  const formattedEmpty = rowData?.map((item, index) => {
    const formattedItem = {}
    for (let key in item) {
      if (item[key] === "" || item[key] === null || item[key] === undefined) {
        formattedItem[key] = ""
      }
      else {
        formattedItem[key] = item[key]
      }
    }
    return formattedItem;
  })
  return formattedEmpty

}
export const questionFlowRedirect = (userData)=>{
  return "/mentee-question";
}
export const menteequestionFlowRedirect = (userData)=>{
 const res= userData?.userinfo
 if(res?.approve_status==="accept"){
   return "/dashboard";
 }else if(res?.application_status==="verified"&&res?.assessment_status==="not_submitted"){
   return "/mentee-review";
 }else {
   return "/mentee-review";
 }
}
export const menteequestionFlowRedirectForHeader = (userData)=>{
  const res= userData?.userinfo
  console.log(res,"res")
  if(res?.approve_status==="accept"){
    return "/dashboard?type=yettojoin";
  }else if(res?.application_status==="verified"&&res?.assessment_status==="not_submitted"){
    return "/mentee-review";
  }else {
    return "/mentee-review";
  }
}